/**
 * Ermöglicht manuelles Einlesen der ScormDaten
 *
 * @class service_v3sLzDebuggerService
 * @memberOf v3sWbtPlayerApp:helper
 */
angular.module('v3sWbtPlayerApp').factory('v3sLzDebuggerService', function () {
    var lzString = "";

    /**
     * Aktiviert die Möglichkeit des Einlesens
     * @memberOf v3sWbtPlayerApp:helper.service_v3sLzDebuggerService
     */
    function activateForOneRequest(str) {
        lzString =  str;
    }

    /**
     * Fragt Benutzer nach LZ String und gibt den zurück
     * @memberOf v3sWbtPlayerApp:helper.service_v3sLzDebuggerService
     * @return LZ String
     */
    function getLzString() {
        var userLzString = lzString;
        lzString = "";

        while (!!userLzString && userLzString.slice(0, 2) !== "lz") {
            userLzString = prompt("Please enter your lz-string:", "lzN4XyA");
        }
        return userLzString;
    }

    return {
        activateForOneRequest: activateForOneRequest,
        getLzString: getLzString
    }
});